import { forwardRef } from "react";
import { Link, LinkProps, useParams, useLocation } from "react-router-dom";
import { LOCALE_PREFIXES } from "@/i18n";

/**
 * Locale-aware Link component.
 * Automatically prepends the current locale prefix to absolute paths.
 * Works both inside and outside the /:locale route context.
 */
export const LocaleLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...props }, ref) => {
    const params = useParams<{ locale: string }>();
    const location = useLocation();

    // Try route params first, then extract from current URL
    let prefix = params.locale;
    if (!prefix) {
      const segments = location.pathname.split("/").filter(Boolean);
      const isKnown = LOCALE_PREFIXES.some((p) => p.prefix === segments[0]);
      prefix = isKnown ? segments[0] : "de";
    }

    const localeTo =
      typeof to === "string" && to.startsWith("/")
        ? `/${prefix}${to}`
        : to;

    return <Link ref={ref} to={localeTo} {...props} />;
  }
);

LocaleLink.displayName = "LocaleLink";
export default LocaleLink;
